import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import FacilityMasterTable from "./FacilityMasterTable";
import btnDownloadIcon from "../../../Assests/download-icon.svg";
import btnSaveIcon from "../../../Assests/Save-btn.svg";
import {
  EditProductTableSuccess,
  ViewProductTableError,
  ViewProductTableStart,
  ViewProductTableSuccess,
  enableEditFilter,
  loadCascadeOptions,
} from "../../../Redux/Actions/InputData";
import { postRequest, putRequest } from "../../../Services/AxiosConfiguration";
import {
  API_BASE_URL,
  BULK_EDIT_MANUFACTURING_MASTER_TABLE_API,
  DISPLAY_MANUFACTURING_MASTER_1_TABLE_API,
  DOWNLOAD_MANUFACTURING_MASTER_1_TABLE_API,
  LONG_FACILITY_MASTER_DOWNLOAD_API,
  LONG_FACILITY_MASTER_GET_API,
  LONG_FACILITY_UPDATE_DATA_API,
  VIEW_MANUFACTURING_MASTER_1_TABLE_API,
} from "../../../Utils/Config";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import axios from "axios";
import FileSaver from "file-saver";
import "./style.css";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import Snackbar from "@mui/material/Snackbar";
import Alert, { AlertProps } from "@mui/material/Alert";

import AddRowButton from "../../../Components/Common/AddRowButton";
import DeleteRowsButton from "../../../Components/Common/DeleteRowsButton";
import ConfirmationDialog from "../../../Components/Common/ConfirmationDialog";
// import plusIcon from "../../../Assests/plus-icon.svg";

let setEmptyTimeCall = false;
let restoreFlag = false;

function FacilityMaster(props: any) {
  const childRef: any = useRef();
  const dispatch: any = useDispatch();
  const [selectFactory, setSelectFactory] = useState<any>("");
  const [selectBasepack, setSelectBasepack] = useState<any>("");
  const [selectCascade, setSelectCascade] = useState<any>("");
  const [selectLine, setSelectLine] = useState<any>("");
  const [rowsData, setRows] = React.useState<any[]>([]);
  const [isProcessed, setIsProcessed] = React.useState(false);
  const [factoryOptions, setFactoryOptions] = React.useState([]);
  const [basepackOptions, setBasepackOptions] = useState<any>([]);
  const [cascadeOptions, setCascadeOptions] = useState<any>([]);
  const [lineOptions, setLineOptions] = useState<any>([]);
  const [getEditedValue, setEditedValue] = useState<any>([]);
  const [open, setOpen] = React.useState(false);

  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId
  );
  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId
  );

  /**Redux state */
  const selectedUsecaseeId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId
  );
  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId
  );

  const selectedFolderData = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderData
  );

  let folderModuleName = selectedFolderData?.folder?.slice(0, 7);
  const [tableName, setTableName] = useState<any>(
    "tblScenario_FacilityMaster_LT"
  );

  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [deletedRows, setDeletedRows] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [isActionEnabled, setIsActionEnabled] = useState(false);
  const handleSelectionChange = (newSelection: any[]) => {
    setSelectedRows(newSelection);
    setIsActionEnabled(newSelection.length > 0);
  };

  useEffect(() => {
    if (folderModuleName === "module2") {
      setTableName("tblScenario_FacilityMaster_LT_Module2");
      getfiltersApi("tblScenario_FacilityMaster_LT_Module2");
    } else if (folderModuleName === "module3") {
      setTableName("tblScenario_FacilityMaster_LT_Module3");
      getfiltersApi("tblScenario_FacilityMaster_LT_Module3");
    } else if (folderModuleName === "module4") {
      setTableName("tblScenario_FacilityMaster_LT_Module4");
      getfiltersApi("tblScenario_FacilityMaster_LT_Module4");
    } else if (folderModuleName === "module5") {
      setTableName("tblScenario_FacilityMaster_LT_Module5");
      getfiltersApi("tblScenario_FacilityMaster_LT_Module5");
    } else if (folderModuleName === "module6") {
      setTableName("tblScenario_FacilityMaster_LT_Module6");
      getfiltersApi("tblScenario_FacilityMaster_LT_Module6");
    } else {
      setTableName("tblScenario_FacilityMaster_LT");
      getfiltersApi("tblScenario_FacilityMaster_LT");
    }
  }, [folderModuleName, selectedScenarioId]);

  const [filterRequest, setFilterRequest] = React.useState([
    { key: "facility_Type", value: "" },
    { key: "facility_code", value: "" },
    { key: "facility_Description", value: "" },
    { key: "flag", value: "" },
  ]);

  const sortedFactoryNames = factoryOptions?.sort((a: any, b: any) =>
    a?.facility_Code.localeCompare(b?.facility_Code)
  );

  const sortedLineNames = lineOptions?.sort((a: any, b: any) =>
    a?.facility_Type.localeCompare(b?.facility_Type)
  );

  var line = 0;
  var base = 0;
  var code = 0;
  var description = 0;
  var type = 0;
  var flag = 0;

  const isEditPopup = useSelector(
    (state: any) => state.InputDataReducers.editPopupFlage
  );

  const handleChangeSelectFactory = (event: any) => {
    setSelectBasepack("");
    setSelectCascade("");
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    const {
      target: { value },
    } = event;
    setSelectFactory(value);
    filterRequest[1].value = value;
    callTableGridApi();
    code = 1;
    description = 0;
    type = 1;
    flag = 0;
  };

  const handleChangeSelectCascade = (event: any) => {
    setEmptyTimeCall = false;
    const {
      target: { value },
    } = event;
    let userVal;
    userVal = value;
    if (value == "-") {
      userVal = "-";
      setEmptyTimeCall = true;
    }
    setSelectBasepack("");
    setSelectCascade(userVal);
    filterRequest[2].value = userVal;
    filterRequest[3].value = "";
    callTableGridApi();
    code = 1;
    description = 1;
    type = 1;
    flag = 0;
  };

  const handleChangeSelectLine = (event: any) => {
    setSelectFactory("");
    setSelectBasepack("");
    setSelectCascade("");
    filterRequest[1].value = "";
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    setEmptyTimeCall = false;
    const {
      target: { value },
    } = event;
    setSelectLine(value);
    filterRequest[0].value = value;
    callTableGridApi();
    code = 0;
    description = 0;
    type = 1;
    flag = 0;
  };

  const handleChangeSelectBasepack = (event: any) => {
    code = 1;
    description = 1;
    type = 1;
    flag = 1;
    const {
      target: { value },
    } = event;
    setSelectBasepack(value);
    filterRequest[3].value = value;
    callTableGridApi();
  };

  const handleDownload = (e: any) => {
    downloadXLSFile();
  };

  const handleAddRow = () => {
    setRows((prev: any) => {
      const emptyRow = {
        id: new Date().getTime(),
        folder_Id: selectedFolderId,
        scenario_id: selectedScenarioId,
        facility_Type: "",
        facility_Code: "",
        facility_Description: "",
        flag: "",
        new_plant_setup_cost: 0,
        plant_closure_cost: 0,
        latitude: 0,
        longitude: 0,
        fix_Cost: 0,
      };

      return prev.length > 0 ? [...prev, emptyRow] : prev;
    });
  };

  const downloadXLSFile = async () => {
    let filterList: any = [];
    if (!restoreFlag) {
      filterList = filterRequest.filter((elem: any) => {
        if (
          elem.key == "facility_Description" &&
          elem.value == "-" &&
          setEmptyTimeCall
        ) {
          return elem;
        } else {
          return elem.value != "";
        }
      });
    }
    const requestParam = {
      usecaseId: 1,
      category_id: 1,
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
      table: tableName,
      time_period: "string",
      filter: filterList,
    };
    // const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblManufacturing1Data", "filter": filterList };
    const urls = API_BASE_URL + LONG_FACILITY_MASTER_DOWNLOAD_API;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      restoreFlag = false;
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver(blob, Date.now() + ".xlsx");
    });
  };

  const callTableGridApi = (resetfilter?: any) => {
    // const filterList = filterRequest.filter((elem: any) => elem.value != '');
    let filterList: any = [];
    if (!restoreFlag) {
      filterList = filterRequest.filter((elem: any) => {
        if (
          elem.key == "facility_Description" &&
          elem.value == "-" &&
          setEmptyTimeCall
        ) {
          return elem;
        } else {
          return elem.value != "";
        }
      });
    }

    console.log(selectedScenarioId, "scenario2");
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId
        : selectedScenarioId;
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table: tableName,
      time_period: "",
      // ispagination: 1,
      // page: 1,
      // pagesize: 100,
      filter: filterList,
    };
    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + LONG_FACILITY_MASTER_GET_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          setIsProcessed(true);
          restoreFlag = false;
          console.log(response.data, requestParam, "basepack2");
          setRows(response.data);
          if (description === 0) {
            setCascadeOptions(loadFacilityDescriptionOptions(response.data));
          }
          if (code === 0) setFactoryOptions(loadFactoryOptions(response.data));
          if (type === 0) {
            setLineOptions(loadLineOptions(response.data));
          }
          if (flag === 0) {
            setBasepackOptions(loadBasePackOptions(response.data));
          }
          dispatch(ViewProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  const loadFactoryOptions = (data: any) => {
    const factoryOptions: any = [];
    data.map((item: any) => {
      const filteredItem = factoryOptions.find((obj: any) => {
        return obj.facility_Code === item.facility_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        factoryOptions.push({ id: item.id, facility_Code: item.facility_Code });
      }
    });
    return factoryOptions;
    //setFactoryOptions(factoryOptions);
  };

  const loadFacilityDescriptionOptions = (data: any) => {
    const factoryOptions: any = [];
    data.map((item: any) => {
      const filteredItem = factoryOptions.find((obj: any) => {
        return obj.facility_Description == null ||
          obj.facility_Description == ""
          ? (obj.facility_Description = "-")
          : obj.facility_Description === item.facility_Description;
      });
      if (filteredItem === undefined || filteredItem == null) {
        factoryOptions.push({
          id: item.id,
          facility_Description: item.facility_Description,
        });
      }
    });
    // Declare a new array
    let newArray = [];

    // Declare an empty object
    let uniqueObject: any = {};

    // Loop for the array elements
    for (let i in factoryOptions) {
      // Extract the title
      let objTitle = factoryOptions[i]["facility_Description"];

      // Use the title as the index
      uniqueObject[objTitle] = factoryOptions[i];
    }

    // Loop to push unique object into array
    let i;
    for (i in uniqueObject) {
      newArray.push(uniqueObject[i]);
    }

    return newArray;
  };

  const loadBasePackOptions = (data: any) => {
    console.log(data, "basepack");
    const basePackOptions: any = [];
    data.map((item: any) => {
      const filteredItem = basePackOptions.find((obj: any) => {
        return obj.flag === item.flag;
      });
      if (filteredItem === undefined || filteredItem == null) {
        basePackOptions.push({ id: item.id, flag: item.flag });
      }
    });
    return basePackOptions;
  };

  const loadLineOptions = (data: any) => {
    const lineOptions: any = [];
    data.map((item: any) => {
      const filteredItem = lineOptions.find((obj: any) => {
        return obj.facility_Type === item.facility_Type;
      });
      if (filteredItem === undefined || filteredItem == null) {
        lineOptions.push({ id: item.id, facility_Type: item.facility_Type });
      }
    });
    return lineOptions;
  };

  const getfiltersApi = (tableeName?: string) => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    //const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblManufacturing1Data", "ispagination": 1, "page": 1, "pagesize": 100, "filter": filterList };
    // const requestParam = { "usecaseId": selectedUsecaseId, "category_id": selectedCategoryId,"folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": selectedScenarioId > 0 ? "tblManufacturingMaster_HC_Rerun" : "tblManufacturingMaster", "time_period": "string","ispagination": 1, "page": 1, "pagesize": 100, "filter": filterList };
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      //  table: scenarioId === 0
      //  ? "tblManufacturingMaster"
      //  : "tblManufacturingMaster_HC_Rerun",
      table: tableeName ?? tableName,

      filter: filterList,
      time_period: "",
    };

    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + LONG_FACILITY_MASTER_GET_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          setIsProcessed(true);
          console.log(response.data, requestParam, "basepack2");
          setRows(response.data);
          console.log(response.data, "response");
          setFactoryOptions(loadFactoryOptions(response.data));
          setBasepackOptions(loadBasePackOptions(response.data));
          setCascadeOptions(loadFacilityDescriptionOptions(response.data));
          setLineOptions(loadLineOptions(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  // useEffect(() => {
  //   // callTableGridApi();
  //   getfiltersApi();
  // }, [
  //   selectedFolderId,
  //   selectedScenarioId,
  //   tableName
  // ]);

  const handleRestoreClicked = (e: any) => {
    restoreFlag = true;
    setEmptyTimeCall = false;
    setSelectFactory("");
    setSelectBasepack("");
    setSelectCascade("");
    setSelectLine("");
    // getfiltersApi();
    filterRequest[0].value = "";
    filterRequest[1].value = "";
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    callTableGridApi(tableName);
  };

  // bulk edit

  const handleClearEditData = (val: any) => {
    console.log(val, "edited array");
  };

  const isEditEnabled = useSelector(
    (state: any) => state.InputDataReducers.editFilterEnable
  );

  const handleFetchEditData = (val: any) => {
    console.log(val, "edited array");
    setEditedValue(val);
  };

  const handleEditSave = (e: any) => {
    const requiredFields = [
      "facility_Type",
      "facility_Code",
      "facility_Description",
      "flag",
      "new_plant_setup_cost",
      "plant_closure_cost",
      "latitude",
      "longitude",
      "fix_Cost",
    ];
    const allMissingFields = new Set<string>();
    getEditedValue.forEach((row: any) => {
      requiredFields.forEach((field) => {
        const value = row[field];
        if (value === undefined || value === null || value === "") {
          // Convert field name to readable format
          const fieldName = field
            .replace(/_/g, " ")
            .replace(/\b\w/g, (l) => l.toUpperCase());
          allMissingFields.add(fieldName);
        }
      });
    });

    if (allMissingFields.size > 0) {
      // Convert Set to Array and join
      const missingFieldsList = Array.from(allMissingFields).join(", ");

      setSnackbar({
        children: `Please fill the required fields: ${missingFieldsList}`,
        severity: "error",
      });
      return; // Prevent the save operation
    }

    handleClickOpen();
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  //const urls = API_BASE_URL + BULK_EDIT_MANUFACTURING_MASTER_TABLE_API;

  const handleDeleteRows = () => {
    if (!selectedRows.length) return;
    setIsDeleteConfirmOpen(true);
  };

  const handleConfirmDeleteRows = () => {
    const updatedRows: any[] = [];
    const rowsToDelete: any[] = [];

    rowsData.forEach((row: any) => {
      if (selectedRows.includes(row.id)) {
        const updated = {
          ...row,
          folder_id: 0,
          folder_Id: 0,
          scenario_id: 0,
          isDelete: true,
        };
        rowsToDelete.push(updated);
      } else {
        updatedRows.push(row);
      }
    });

    setRows(updatedRows);

    if (rowsToDelete.length > 0) {
      // Store deleted rows separately
      setDeletedRows((prev: any[]) => [...prev, ...rowsToDelete]);

      setIsDeleteConfirmOpen(false);
      setSelectedRows([]);
      setIsActionEnabled(false);

      const dataToSave =
        getEditedValue && getEditedValue.length > 0
          ? [
              ...getEditedValue.filter(
                (row: any) => row && Object.keys(row).length > 0
              ),
              ...rowsToDelete,
            ]
          : rowsToDelete;

      handleAgree(dataToSave, "Record deleted successfully");
    } else {
      setIsDeleteConfirmOpen(false);
    }
  };

  const handleAgree = (dataToSave: any[], successMessage: string) => {
    const transformedRows = dataToSave.map((row: any) => {
      if (row.isNew) {
        const { isNew, ...rest } = row;
        rest.id = 0;
        return rest;
      } else if (row.isDelete) {
        const { isDelete, ...rest } = row;
        rest.folder_id = 0;
        rest.Scenario_Id = 0;
        return rest;
      }

      return row;
    });
    const urls = API_BASE_URL + LONG_FACILITY_UPDATE_DATA_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    const payload = {
      moduleKey: Number(folderModuleName.slice(-1)),
      data: transformedRows,
    };
    putRequest(urls, payload, header, {})
      .then((response) => {
        if (response.status == 200) {
          callTableGridApi();
          setSnackbar({
            children: successMessage,
            severity: "success",
          });
          handleClose();
          //dispatch(enableEditFilter(false, "handlecat"));
          childRef?.current?.ClearEditedData();
          dispatch(EditProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        setSnackbar({
          children: "Something went wrong please try again!",
          severity: "error",
        });
        // dispatch(enableEditFilter(false, "handlecat"));
        handleClose();
      });
  };

  // bulk edit

  const [snackbar, setSnackbar] = React.useState<Pick<
    AlertProps,
    "children" | "severity"
  > | null>(null);

  const handleCloseSnackbar = () => setSnackbar(null);

  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        className="Dialogbox-display"
      >
        <DialogTitle
          id="responsive-dialog-title"
          className="responsive-dialog-title-txt"
        >
          {"Confirmation for Edit"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className="md-alert-clr">
            {getEditedValue.length > 0
              ? "Do you want to submit the edited FacilityMaster table data?"
              : "Please Edit any value to save!"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {getEditedValue.length > 0 ? (
            <>
              <Button className="modal-btn-b" autoFocus onClick={handleClose}>
                No
              </Button>
              <Button
                className="modal-btn-b"
                onClick={() =>
                  handleAgree(getEditedValue, "Successfully saved")
                }
                autoFocus
              >
                Yes
              </Button>
            </>
          ) : (
            <Button className="modal-btn-b" autoFocus onClick={handleClose}>
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <ConfirmationDialog
        open={isDeleteConfirmOpen}
        onClose={() => setIsDeleteConfirmOpen(false)}
        onConfirm={handleConfirmDeleteRows}
        title="Confirmation for Delete"
        page="Facility Master"
        confirmText="Yes"
        cancelText="No"
        fullScreen={fullScreen}
      />
      <div className="Compare">
        <div className="filter-section">
          <div className="page-title">
            <h3>Facility Master</h3>
          </div>
          <div className="filters">
            <span title="Reset">
              <RestoreOutlinedIcon
                className="restoreIcon"
                onClick={(e) => handleRestoreClicked(e)}
              />
            </span>
            {/* <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                <InputLabel>Faclity Type</InputLabel>
                <Select
                  id="simple-select-3"
                  value={selectLine}
                  placeholder="Select Line"
                  onChange={handleChangeSelectLine}
                  renderValue={(selectLine: any) => selectLine}
                  className="select-short-term"
                >
                  {sortedLineNames?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.facility_Type}>
                        {d.facility_Type}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div> */}
            <AddRowButton
              isEditEnabled={isEditEnabled && !isActionEnabled}
              handleAddRow={handleAddRow}
            />
            <DeleteRowsButton
              isEditEnabled={isEditEnabled && isActionEnabled}
              handleDeleteRows={handleDeleteRows}
            />
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Faclity Type</InputLabel> */}
                <Select
                  id="simple-select-3"
                  value={selectLine}
                  placeholder="Select Line"
                  onChange={handleChangeSelectLine}
                  // renderValue={(selectLine: any) => selectLine}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Faclity Type</em>
                  </MenuItem>
                  {sortedLineNames?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.facility_Type}>
                        {d.facility_Type}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Facility Code</InputLabel> */}
                {/* <InputLabel>Facility Code</InputLabel> */}
                <Select
                  id="simple-select-1"
                  value={selectFactory}
                  placeholder="Select Factory"
                  onChange={handleChangeSelectFactory}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Facility Code</em>
                  </MenuItem>
                  {sortedFactoryNames?.map((d: any) => {
                    // return (<MenuItem key={d} value={d.factory}>{d.factory}</MenuItem>)
                    return (
                      <MenuItem key={d} value={d.facility_Code}>
                        {d.facility_Code}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Facility Description</InputLabel> */}
                <Select
                  id="simple-select-2"
                  value={selectCascade}
                  placeholder="Select Cascade"
                  onChange={handleChangeSelectCascade}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Facility Description</em>
                  </MenuItem>
                  {cascadeOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.facility_Description}>
                        {d.facility_Description}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Flag</InputLabel> */}
                <Select
                  id="simple-select-4"
                  value={selectBasepack}
                  placeholder="Select Basepack"
                  onChange={handleChangeSelectBasepack}
                  // renderValue={(selectBasepack: any) => selectBasepack}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Flag</em>
                  </MenuItem>
                  {basepackOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.flag}>
                        {d.flag}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            {isEditEnabled && isEditPopup && (
              <FormControl fullWidth>
                <div
                  className="content-save-btn"
                  onClick={(e) => handleEditSave(e)}
                >
                  <img src={btnSaveIcon} alt="" /> <span> Save</span>
                </div>
              </FormControl>
            )}

            <div className="filter-item">
              <FormControl fullWidth>
                <div
                  className={`content-download-btn ${
                    isActionEnabled ? "disabled" : ""
                  }`}
                  onClick={(e) => handleDownload(e)}
                >
                  <img src={btnDownloadIcon} alt="" /> <span> Download</span>
                </div>
              </FormControl>
            </div>
          </div>
        </div>
      </div>
      <div>
        <FacilityMasterTable
          ref={childRef}
          isProcessed={isProcessed}
          rowsData={rowsData}
          handleGetEditData={handleFetchEditData}
          handleClearEditData={handleClearEditData}
          setRows={setRows}
          handleSelectionChange={handleSelectionChange}
          selectedRows={selectedRows}
        />
        {!!snackbar && (
          <Snackbar
            open
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={handleCloseSnackbar}
            autoHideDuration={6000}
          >
            <Alert {...snackbar} onClose={handleCloseSnackbar} />
          </Snackbar>
        )}
      </div>
    </>
  );
}

export default FacilityMaster;
